import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { formatDateTime } from 'src/util/Dates';
import { GradientTypography } from 'src/components/gradients/GradientTypography';
import { ImageOptimized } from './image/ImageOptimized';

export type MaintenceModeProps = {
  children: React.ReactNode;
};

export function MaintenanceMode({ children }: MaintenceModeProps) {
  const untilMillis = process.env.NEXT_PUBLIC_MAINTENANCE_UNTIL;
  if (!untilMillis || untilMillis === 'false') {
    return <>{children}</>;
  }

  const until =
    Number(untilMillis) > Date.now() && new Date(Number(untilMillis));
  const untilFormatted = until
    ? formatDateTime(until, { separator: '  ' })
    : 'soon';

  return (
    <Stack
      direction="column"
      alignItems="center"
      sx={{ px: 16, pt: 24, height: '100vh', textAlign: 'center' }}
    >
      <ImageOptimized
        src="/assets/images/mascots/mascot_building.png"
        width={480}
        height={480}
        objectFit="contain"
        alt="BluMint Maintenance Mascot"
      />
      <GradientTypography
        gradientColor="primary.vertical"
        variant="h4"
        sx={{ fontWeight: 600 }}
      >
        BluMint is under maintenance.
      </GradientTypography>
      <Typography variant={'h6'} sx={{ mt: 4 }}>
        {`We'll be back ${untilFormatted} with new features!`}
      </Typography>
    </Stack>
  );
}
